"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinsModernTightenedDetailedView = SpinsModernTightenedDetailedView;
exports.usePageStart = exports.useFetchMoreSpinsData = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uxUtils = require("@site/ux-utils");
var _utils = require("./utils");
var _SpinsHeader = require("./SpinsHeader");
var _DomainEntries = _interopRequireDefault(require("./SpinResults/DomainEntries"));
var _useApiData = require("./hooks/useApiData");
var _RequestApiType = _interopRequireDefault(require("./constants/RequestApiType"));
var _SpinAddToCartButton = _interopRequireDefault(require("./SpinResults/SpinAddToCartButton"));
var _sharedComponents = require("@site/shared-components");
var _LoadingEmptyStateContent = _interopRequireDefault(require("./components/LoadingEmptyStateContent"));
var _SpinsComponentLoader = require("./SpinsComponentLoader");
var _domainServices = require("@site/domain-services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable complexity */

const usePageStart = ({
  isMounted,
  initialPageStart,
  isVisible,
  numberOfSpinsPerCall,
  numberOfSpinsCalls,
  enableInfiniteScrolling
}) => {
  const [pageStart, setPageStart] = (0, _react.useState)(0);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [stopLoading, setStopLoading] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (isVisible && enableInfiniteScrolling && !stopLoading) {
      const newPageStart = !isMounted.current ? initialPageStart : pageStart + numberOfSpinsPerCall;
      if (!isMounted.current) {
        isMounted.current = true;
      }
      if (newPageStart > numberOfSpinsPerCall * (numberOfSpinsCalls + 1)) {
        setStopLoading(true);
      } else {
        setLoading(true);
        setPageStart(newPageStart);
      }
    }
  }, [isVisible]);
  return {
    pageStart,
    stopLoading,
    loading,
    setLoading,
    setStopLoading
  };
};
exports.usePageStart = usePageStart;
const useFetchMoreSpinsData = ({
  pageStart,
  options,
  isVisible,
  stopLoading,
  apm,
  setLoading,
  setStopLoading
}) => {
  let timeout;
  const [moreSpinsRecommendedDomains, setMoreSpinsRecommendedDomains] = (0, _react.useState)([]);
  options = {
    ...options,
    numberOfSpins: options?.numberOfSpinsPerCall
  };
  (0, _react.useEffect)(() => {
    const fetchMoreSpinsData = async () => {
      const spinsOptions = {
        ...options,
        ...options.extraApiParam,
        pagestart: pageStart
      };
      try {
        const newSpinsData = await (0, _domainServices.getSpinsPromise)(spinsOptions, spinsOptions?.resellerBaseOverride, apm);
        const {
          showFreeIndicator,
          maxSpins = 40,
          cart,
          numberOfSpinsPerCall
        } = options;
        const newRecommendedDomains = (0, _utils.transformSpinData)({
          findResponse: newSpinsData?.data,
          showFreeIndicator,
          maxSpins,
          cart
        });

        // sometimes FIND API returns lesser spins than what was asked then we are done.
        const isNumberOfNewSpinsEnough = newRecommendedDomains.length >= numberOfSpinsPerCall;
        !isNumberOfNewSpinsEnough && setStopLoading(true);
        isNumberOfNewSpinsEnough && setMoreSpinsRecommendedDomains([...moreSpinsRecommendedDomains, ...newRecommendedDomains]);
      } catch (error) {
        // if FIND API does not return as expected then we stop asking for more
        // eslint-disable-next-line no-console
        console.error('Spins API returned failure while infinite scroll:', error);
        setStopLoading(true);
      }
      timeout = clearTimeout(timeout);
      timeout = setTimeout(() => {
        setLoading(false);
      }, 400);
    };
    options?.enableInfiniteScrolling && isVisible && !stopLoading && fetchMoreSpinsData();
  }, [pageStart]);
  return moreSpinsRecommendedDomains;
};
exports.useFetchMoreSpinsData = useFetchMoreSpinsData;
function SpinsModernTightenedDetailedView(props) {
  const {
    language = {}
  } = {
    ...props
  };
  const {
    overrideProps,
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  const {
    spinsResponse = {},
    options = {},
    AddToCartButton,
    PriceBlock,
    CustomCartStateBadge,
    CelebrateDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
    SpinInCartExpandedComponent = () => /*#__PURE__*/_react.default.createElement("div", null),
    PremiumDetailView = () => /*#__PURE__*/_react.default.createElement("div", null),
    SpinsSolutionSets = () => /*#__PURE__*/_react.default.createElement("div", null),
    enableDynamicFontScaling = false,
    cartContents,
    requestApiType,
    apm,
    customLoadingSpinner,
    ctaProps = {},
    emptyStateComponent,
    onSuccessApiData,
    spinsHeaderComponent
  } = {
    ...props,
    ...overrideProps
  };
  const {
    numberOfSpinsCalls = 5,
    numberOfSpinsPerCall = 20,
    enableInfiniteScrolling = false,
    extraApiParam,
    apiKey,
    env
  } = options;
  const {
    spinsData,
    requestStatus
  } = (0, _useApiData.useApiData)(requestApiType, {
    ...options,
    ...extraApiParam
  }, apm, onSuccessApiData);
  const spinsResponseData = requestApiType ? spinsData : spinsResponse;
  const targetRef = (0, _react.useRef)(null);
  const isMounted = (0, _react.useRef)(false);
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const initialPageStart = spinsResponseData?.RecommendedDomains?.length || 0;
  const {
    pageStart,
    stopLoading,
    loading,
    setLoading,
    setStopLoading
  } = usePageStart({
    isMounted,
    initialPageStart,
    isVisible,
    numberOfSpinsPerCall,
    numberOfSpinsCalls,
    enableInfiniteScrolling
  });
  const moreSpinsRecommendedDomains = useFetchMoreSpinsData({
    pageStart,
    options,
    isVisible,
    stopLoading,
    apm,
    setLoading,
    setStopLoading
  });
  const intersectionObserverCallback = ([entry], observer) => {
    if (entry.isIntersecting && !isVisible) {
      setIsVisible(entry.isIntersecting);
    } else if (!entry.isIntersecting && isVisible) {
      observer.unobserve(entry.target);
      setIsVisible(entry.isIntersecting);
    }
  };
  (0, _react.useEffect)(() => {
    if (enableInfiniteScrolling) {
      const observer = new IntersectionObserver(intersectionObserverCallback, {
        rootMargin: '200px',
        threshold: [0]
      });
      if (targetRef.current) {
        observer.observe(targetRef.current);
      }
      return () => {
        if (targetRef.current) {
          observer.unobserve(targetRef.current);
        }
      };
    }
  });
  const {
    market = 'en-US',
    showFreeIndicator,
    removeTopBorder,
    spinsHeader: {
      showSpinsHeader
    } = {},
    maxSpins = 40,
    isSpinExpandable
  } = options;
  const dataCy = 'spins-modern-tightened-detailed-view';
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const showLoadMoreButton = false;
  const recommendedDomains = (0, _utils.transformSpinData)({
    findResponse: spinsResponseData,
    showFreeIndicator,
    maxSpins
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": dataCy,
    className: (0, _classnames.default)('spin-and-filter-wrap', 'bg-white', {
      'card-view': isMobile,
      'pb-4': !isMobile && !showLoadMoreButton
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex align-items-end', {
      'justify-content-between': showSpinsHeader,
      'justify-content-end': !showSpinsHeader
    })
  }, showSpinsHeader && /*#__PURE__*/_react.default.createElement(_SpinsHeader.SpinsHeader, {
    options: options
  }), spinsHeaderComponent), /*#__PURE__*/_react.default.createElement(_LoadingEmptyStateContent.default, {
    requestApiType,
    requestStatus,
    emptyStateComponent,
    customLoadingSpinner,
    recommendedDomains
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('detailed-v-panel panel panel-default', {
      'remove-top-border': removeTopBorder && !isSpinExpandable
    })
  }, recommendedDomains.length > 0 && /*#__PURE__*/_react.default.createElement(_DomainEntries.default, {
    spinResultsWrapRef: targetRef,
    language: languageStrings,
    recommendedDomains: recommendedDomains,
    dataCy: "tight-modern-spin",
    options: options,
    PriceBlock: PriceBlock,
    ctaProps: {
      apiKey: apiKey,
      env: env,
      ...ctaProps
    },
    CustomCartStateBadge: CustomCartStateBadge,
    AddToCartButton: AddToCartButton,
    CelebrateDetailView: CelebrateDetailView,
    SpinInCartExpandedComponent: SpinInCartExpandedComponent,
    PremiumDetailView: PremiumDetailView,
    SpinsSolutionSets: SpinsSolutionSets,
    showDetailView: true,
    enableDynamicFontScaling: enableDynamicFontScaling,
    cartContents: cartContents,
    apm: apm,
    moreSpinsRecommendedDomains: moreSpinsRecommendedDomains
  }), loading && enableInfiniteScrolling && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center justify-content-center pb-3"
  }, /*#__PURE__*/_react.default.createElement(_SpinsComponentLoader.SpinsComponentLoader, null)))))));
}
const ctaPropsPropTypes = {
  ..._SpinAddToCartButton.default.propTypes
};
delete ctaPropsPropTypes.product;
SpinsModernTightenedDetailedView.propTypes = {
  language: _propTypes.default.object,
  spinsResponse: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  CelebrateDetailView: _propTypes.default.func,
  PremiumDetailView: _propTypes.default.func,
  SpinsSolutionSets: _propTypes.default.func,
  enableDynamicFontScaling: _propTypes.default.object,
  cartContents: _propTypes.default.shape({
    has: _propTypes.default.func
  }),
  SpinInCartExpandedComponent: _propTypes.default.element,
  CustomCartStateBadge: _propTypes.default.element,
  requestApiType: _propTypes.default.oneOf(_RequestApiType.default),
  apm: _propTypes.default.object,
  customLoadingSpinner: _propTypes.default.element,
  ctaProps: _propTypes.default.shape(ctaPropsPropTypes),
  emptyStateComponent: _propTypes.default.element,
  onSuccessApiData: _propTypes.default.func,
  spinsHeaderComponent: _propTypes.default.element
};
const SpinsModernTightenedDetailedViewWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    plid,
    urlOverride,
    options: {
      enableFavorites
    } = {},
    uipProps,
    forceEnableBFF
  } = props;
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    appName: appName,
    componentName: "spins",
    apiKey: apiKey,
    forceEnableBFF: forceEnableBFF,
    loader: /*#__PURE__*/_react.default.createElement(_SpinsComponentLoader.SpinsComponentLoader, null)
  }, enableFavorites && {
    uipProps: {
      plid,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(SpinsModernTightenedDetailedView, props));
};
SpinsModernTightenedDetailedViewWithComponentDataProvider.propTypes = {
  ...SpinsModernTightenedDetailedView.propTypes,
  uipProps: _propTypes.default.object,
  forceEnableBFF: _propTypes.default.bool
};
var _default = exports.default = SpinsModernTightenedDetailedViewWithComponentDataProvider;